import { PlatformTermsAcceptSection } from './PlatformTermsAcceptSection';

export type AssetCreateTermsSectionProps = {
  menuId: string;
  open: boolean;
  agreed: boolean;
  onToggleOpen: () => void;
  onAgreedChange: (agreed: boolean) => void;
};

export function AssetCreateTermsSection({
  menuId,
  open,
  agreed,
  onToggleOpen,
  onAgreedChange,
}: AssetCreateTermsSectionProps) {
  return (
    <PlatformTermsAcceptSection
      idPrefix={`${menuId}-create`}
      open={open}
      agreed={agreed}
      theme="dark"
      termsVariant="assetOwner"
      onToggleOpen={onToggleOpen}
      onAgreedChange={onAgreedChange}
    />
  );
}
